const reasons = [
  {
    icon: 'fa-medal',
    title: '20+ Years of Proven Mastery',
    desc: 'Two decades of hands-on experience building fences across Camden County. Mastery that only comes from sustained, dedicated craft.',
  },
  {
    icon: 'fa-palette',
    title: 'Fully Custom Solutions',
    desc: 'We design around your property, your goals, and your vision — creating fences that seamlessly balance security, privacy, and aesthetics.',
  },
  {
    icon: 'fa-tag',
    title: 'Transparent, Honest Pricing',
    desc: 'No hidden fees, no surprises. Exceptional craftsmanship at fair rates, plus $100 off for same-day signing on your estimate.',
  },
  {
    icon: 'fa-handshake',
    title: 'Deeply Local & Trusted',
    desc: "Our reputation in this community is everything. We show up on time, communicate clearly, and stand behind every project we complete.",
  },
  {
    icon: 'fa-clock',
    title: 'Precise, On-Schedule Delivery',
    desc: 'We respect your property and your schedule. Our crew maintains a clean worksite and consistently delivers on the agreed timeline.',
  },
  {
    icon: 'fa-shield-halved',
    title: 'Licensed, Insured & Certified',
    desc: 'Full credentials, full accountability. Masters Fencing is licensed and insured in Georgia — your investment is completely protected.',
  },
];

const WhyChooseUs: React.FC = () => (
  <section className="relative overflow-hidden">
    <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[700px]">

      {/* Image panel */}
      <div className="relative h-80 lg:h-auto overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/0316fd46d46faf00a8121cb1b59ccba9.jpg"
          alt="Masters Fencing — expert craftsman at work in St. Mary's Georgia"
          title="Expert fencing craftsmanship — Masters Fencing"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0D0C0B]/90 via-[#0D0C0B]/25 to-transparent" />

        {/* Quote */}
        <div className="absolute bottom-0 left-0 right-0 p-10 lg:p-12">
          <div className="border-l-2 border-[#C4A84F] pl-6 mb-8">
            <p className="font-serif text-[1.5rem] md:text-[1.8rem] text-[#F5F1E8] italic leading-snug mb-3">
              "A fence built right is a fence that lasts a lifetime."
            </p>
            <p className="text-[#C4A84F] text-[10px] tracking-[0.28em] uppercase font-sans font-medium">
              — Josh Masters · Masters Fencing, St. Mary's GA
            </p>
          </div>
        </div>

        {/* Badge */}
        <div className="absolute top-8 right-8 w-24 h-24 flex flex-col items-center justify-center bg-[#C4A84F]">
          <span className="font-serif text-3xl leading-none font-bold text-[#0D0C0B]">20+</span>
          <span className="text-[9px] tracking-[0.14em] uppercase font-sans font-bold mt-1 text-center leading-tight text-[#0D0C0B]/80">
            Years<br />Expert
          </span>
        </div>
      </div>

      {/* Content panel */}
      <div className="bg-[#0D0C0B] section-py px-8 lg:px-16 reveal-right">
        <div className="flex items-center gap-3 mb-7">
          <span className="gold-bar" />
          <span className="text-[#C4A84F] text-[11px] tracking-[0.38em] uppercase font-sans font-medium">
            The Masters Difference
          </span>
        </div>
        <h2 className="font-serif text-[3rem] md:text-[4rem] text-[#F5F1E8] leading-[0.95] mb-14">
          Why St. Mary's Chooses Masters Fencing
        </h2>

        <div className="space-y-7 stagger">
          {reasons.map((r) => (
            <div key={r.title} className="reveal flex items-start gap-5 group">
              <div className="w-11 h-11 flex items-center justify-center shrink-0 border border-[#C4A84F]/28 group-hover:bg-[#C4A84F] group-hover:border-[#C4A84F] transition-all duration-300">
                <i className={`fa-solid ${r.icon} text-sm text-[#C4A84F] group-hover:text-[#0D0C0B] transition-colors`} />
              </div>
              <div>
                <h3 className="font-sans font-semibold text-[#F5F1E8] text-sm tracking-wide mb-1.5">
                  {r.title}
                </h3>
                <p className="text-[#F5F1E8]/42 text-sm leading-relaxed font-sans">
                  {r.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-10 border-t border-[#C4A84F]/12 flex flex-col sm:flex-row gap-4">
          <a href="#estimate" className="btn-gold">
            <i className="fa-regular fa-calendar-check text-[11px]" />
            Get Your Free Estimate
          </a>
          <a href="tel:912-409-2031" className="btn-outline-light">
            <i className="fa-solid fa-phone text-[11px]" />
            912-409-2031
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default WhyChooseUs;
